import DatePickerMode from '../../types/DatePickerMode';

import supportsBothMultiAndSingleDay from './supportsBothMultiAndSingleDay';

const determineCompatibilityForSingleOrMultiDay = (
    customerWantsMultipleDays: boolean | undefined,
    subject: DatePickerMode
): boolean => {
    if (
        customerWantsMultipleDays === undefined ||
        supportsBothMultiAndSingleDay(subject)
    ) {
        return true;
    }

    const subjectSupportsOnlySingleDay = subject === 'OnlySingleDay';

    return customerWantsMultipleDays !== subjectSupportsOnlySingleDay;
};

export default determineCompatibilityForSingleOrMultiDay;
